import { isInt } from 'validator'

export default [
  {
    name: 'name',
    validation: [
      name => !name && 'A name is required.',
    ],
  },
  {
    name: 'pcType',
    validation: [
      pcType => !pcType && 'A discount type is required.',
    ],
  },
  {
    name: 'value',
    validation: [
      value => !value && 'A value is required.',
    ],
  },
  {
    name: 'onsaleTime',
    validation: [
      onsaleTime => !onsaleTime && 'An onsale time is required.',
    ],
  },
  {
    name: 'offsaleTime',
    validation: [
      offsaleTime => !offsaleTime && 'An offsale time is required.',
    ],
  },
  {
    name: 'totalLimit',
    validation: [
      totalLimit => !totalLimit && 'A total limit is required.',
      totalLimit => totalLimit && !isInt(totalLimit, { min: 0 }) && 'Total limit must be a positive integer.',
    ],
  },
  {
    name: 'limitPerCustomer',
    validation: [
      limitPerCustomer => !limitPerCustomer && 'A limit per customer is required.',
      limitPerCustomer =>
        limitPerCustomer && !isInt(limitPerCustomer, { min: 0 }) && 'Limit per customer must be a positive integer.',
    ],
  },
]



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-form/fields.js
 **/